import axios from 'axios'
import { ICrudDeleteAction, ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudSearchAction } from 'react-jhipster'

import { cleanEntity } from '../../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../action-type.util'

import { defaultValue, IPlayerProfile } from '../../model/player-profile.model'

export const ACTION_TYPES = {
  SEARCH_PLAYERPROFILES: 'playerProfile/SEARCH_PLAYERPROFILES',
  FETCH_PLAYERPROFILE_LIST: 'playerProfile/FETCH_PLAYERPROFILE_LIST',
  FETCH_PLAYERPROFILE: 'playerProfile/FETCH_PLAYERPROFILE',
  CREATE_PLAYERPROFILE: 'playerProfile/CREATE_PLAYERPROFILE',
  UPDATE_PLAYERPROFILE: 'playerProfile/UPDATE_PLAYERPROFILE',
  DELETE_PLAYERPROFILE: 'playerProfile/DELETE_PLAYERPROFILE',
  SET_BLOB: 'playerProfile/SET_BLOB',
  RESET: 'playerProfile/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPlayerProfile>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type PlayerProfileState = Readonly<typeof initialState>;

// Reducer

export default (state: PlayerProfileState = initialState, action): PlayerProfileState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.SEARCH_PLAYERPROFILES):
    case REQUEST(ACTION_TYPES.FETCH_PLAYERPROFILE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PLAYERPROFILE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PLAYERPROFILE):
    case REQUEST(ACTION_TYPES.UPDATE_PLAYERPROFILE):
    case REQUEST(ACTION_TYPES.DELETE_PLAYERPROFILE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.SEARCH_PLAYERPROFILES):
    case FAILURE(ACTION_TYPES.FETCH_PLAYERPROFILE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PLAYERPROFILE):
    case FAILURE(ACTION_TYPES.CREATE_PLAYERPROFILE):
    case FAILURE(ACTION_TYPES.UPDATE_PLAYERPROFILE):
    case FAILURE(ACTION_TYPES.DELETE_PLAYERPROFILE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.SEARCH_PLAYERPROFILES):
    case SUCCESS(ACTION_TYPES.FETCH_PLAYERPROFILE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_PLAYERPROFILE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PLAYERPROFILE):
    case SUCCESS(ACTION_TYPES.UPDATE_PLAYERPROFILE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PLAYERPROFILE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const apiUrl = 'api/player-profiles';
const apiSearchUrl = 'api/_search/player-profiles';

// Actions

export const getSearchEntities: ICrudSearchAction<IPlayerProfile> = (query, page, size, sort) => ({
  type: ACTION_TYPES.SEARCH_PLAYERPROFILES,
  payload: axios.get<IPlayerProfile>(`${apiSearchUrl}?query=${query}${sort ? `&page=${page}&size=${size}&sort=${sort}` : ''}`),
});

export const getEntities: ICrudGetAllAction<IPlayerProfile> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_PLAYERPROFILE_LIST,
    payload: axios.get<IPlayerProfile>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IPlayerProfile> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_PLAYERPROFILE,
    payload: axios.get<IPlayerProfile>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IPlayerProfile> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PLAYERPROFILE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IPlayerProfile> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PLAYERPROFILE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IPlayerProfile> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PLAYERPROFILE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
